export const ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_ITEMS_IN_ROW = 4

export const ENTITY_PROFILE_HEADER_INFO_ITEMS_MAX_LOADING_ITEMS_IN_ROW = 3

export const ENTITY_PROFILE_HEADER_INFO_ITEMS_LOADING_ITEMS_LENGTH = 6
